import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'ins-damage-claim-title',
    templateUrl: 'damage-claim-title.component.html',
    styleUrls: [ 'damage-claim-title.component.scss' ],
})

export class DamageClaimTitleComponent {
    @Input() expand: boolean = false;
    @Input() title: string = '';
    @Input() icon: string = '';
    @Output() readonly openTitle = new EventEmitter<void>();
    @Output() readonly closeTitle = new EventEmitter<void>();
}
